{
    "back_to_login": "Back",
    "email": "Email",
    "forgotten_Pwd": {
        "title": "Forgotten password ?",
        "description_1": "Indicate your login email.",
        "description_2": "You will receive a link to reset your password to this address.",
        "description_warning": "Link is available for the next 72 hours.",
        "success": "An email was sent to the following address :"
    },
    "password": "Password",
    "send_reset_mail": "Send",
    "totp": {
        "title": "Two-factor authentication",
        "input_label": "Enter a one-time code to complete the connection",
        "submit": "Check the code",
        "no_access_message": "Can\\'t access your account?"
    }
}